import React from 'react';
import ProposalDiscount from '../ProposalDiscount';
import ProposalPending from '../ProposalPending';
import Action1 from './Action1';
import Action2 from './Action2';
import Action4 from './Action4';
import Action5 from './Action5';
import Action6 from './Action6';
import Action7 from './Action7';
import ActionViewSubStatus from './ActionViewSubStatus';
import ProposalProject from '../ProposalProject';
import Action9 from './Action9';
import CheckDocumentsAdditionalInformation from './CheckDocumentsAdditionalInformation';

interface IProp {
  proposal: any;
  status: any;
  pendingsProposal: any;
  setProposal: React.Dispatch<React.SetStateAction<any>>;
}

const ProposalActions = ({ proposal, status, pendingsProposal, setProposal }: IProp) => {
  if (!status || proposal.idProposalStatus !== status.idProposalStatus) return null;

  const nameProposalType = proposal?.proposalType?.name ?? '';
  const namestatus = status?.proposalStatus?.name ?? '';
  
  if (nameProposalType === 'Solar Direct') { //Solar Direct
    switch (namestatus) {
      case 'Elaboração de Proposta':
        return (<>
          <Action1 proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      case 'Proposta Gerada':
        return (<>
          <Action2 proposal={proposal} statusActual={status} />
          {
            (((proposal.proposalFileValid ?? true) && proposal.proposalFile) || proposal.statusDiscount === 1 || proposal.statusDiscount === 2) &&
              <ProposalDiscount proposal={proposal} setProposal={setProposal} />
          }
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      case 'Pagamento Sinal':
        return <>
          <CheckDocumentsAdditionalInformation proposal={proposal}/>
          <Action5 proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>
      case 'Analise de Crédito':
        return(<>
          <CheckDocumentsAdditionalInformation proposal={proposal}/>
          <ActionViewSubStatus proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>)
      case 'Viabilidade Técnica':
        return(<>
          <CheckDocumentsAdditionalInformation proposal={proposal}/>
          <ActionViewSubStatus proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>)
      case 'Readequação de Proposta':
        return (<>
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      case 'Aguardando Aceite':
        return (<>
          <CheckDocumentsAdditionalInformation proposal={proposal}/>
          <ProposalDiscount proposal={proposal} setProposal={setProposal} />
          {/* <Action7 proposal={proposal} statusActual={status} /> */}
          <Action6 proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      case 'Projeto':
        return (<>
          <ProposalProject proposal={proposal} />
        </>);
      case 'Contrato':
      case 'Viabilidade Técnica':
      case 'Encerrado':
        return <>
          <ActionViewSubStatus proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>;
      default:
        return null;
    }
  }
  if (nameProposalType === 'Ezee Connect') { //Ezee Connect
    switch (namestatus) {
      case 'Proposta Enviada':
        return (<>
          <Action4 proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      case 'Contrato':
      case 'Validação':
      case 'Finalizado':
      case 'Encerrado':
        return (
          <>
            <ActionViewSubStatus proposal={proposal} statusActual={status} />
            <ProposalPending proposal={proposal} pendings={pendingsProposal} />
          </>
        )
      default:
        return null;
    }
  }
  if (nameProposalType === 'Ezee Livre') { //Ezee Livre
    switch (namestatus) {
      case 'Proposta Enviada':
        return (<>
          <Action9 proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      case 'Negociação':
        return (<>
          <Action7 proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      case 'Apresentação Comercial':
      case 'Contrato':
      case 'Encerrado':
        return (<>
          <ActionViewSubStatus proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      default:
        return null;
    }
  }
  if (nameProposalType === 'Serviços') { //Serviços
    switch (namestatus) {
      case 'Contrato':
      case 'Pagamento':
      case 'Encerrado':
        return (<>
          <ActionViewSubStatus proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      default:
        return null;
    }
  }
  if (nameProposalType === 'Produtos') { //Produtos
    switch (namestatus) {
      case 'Proposta Enviada':
        return (<>
          {(proposal?.cashValue ?? 0) > 0 && <ProposalDiscount proposal={proposal} />}
          <Action2 proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      case 'Aguardando Aceite':
        return (<>
          <Action6 proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      case 'Pagamento':
      case 'Viabilidade Técnica':
      case 'Contrato':
      case 'Projeto':
      case 'Encerrado':
        return (<>
          <ActionViewSubStatus proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      default:
        return null;
    }
  }
  if (nameProposalType === 'Ezee Solar - Grupo A' && Number(proposal.grupoTarifario ?? 0) === 1) { //Ezee Solar - Grupo A
    switch (namestatus) {
      case 'Projeto':
        return (<ProposalProject proposal={proposal} />);
      case 'Viabilidade Técnica':
      case 'Contrato':
      case 'Aguardando Aceite':
      case 'Encerrado':
        return (<>
          <ActionViewSubStatus proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      case 'Proposta Enviada':
        return (<>
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      case 'Readequação de Proposta':
        return (<>
          <Action2 proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      default:
        return null;
    }
  }
  if (nameProposalType === 'Ezee Solar - Grupo B' && Number(proposal.grupoTarifario ?? 0) === 2) { //Ezee Solar - Grupo B
    switch (namestatus) {
      case 'Análise de Crédito':
        return (<>
          <ActionViewSubStatus proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      case 'Informações adicionais':
        return (<>
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      case 'Projeto':
        return (<>
          <ProposalProject proposal={proposal} />
        </>);
      case 'Contrato':
      case 'Viabilidade Técnica':
      case 'Encerrado':
        return (<>
          <ActionViewSubStatus proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      default:
        return null;
    }
  }
  if (nameProposalType === 'Enerzee Recharge') { //Enerzee Recharge
    switch (namestatus) {
      case 'Termo Enviado':
        return (<>
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      case 'Contrato':
      case 'Pagamento do Contrato':
      case 'Encerrado':
        return (<>
          <ActionViewSubStatus proposal={proposal} statusActual={status} />
          <ProposalPending proposal={proposal} pendings={pendingsProposal} />
        </>);
      default:
        return null;
    }
  }
  return null;
};

export default ProposalActions;
